import { defineComponent as r, openBlock as a, createBlock as o, unref as p, mergeProps as c, withCtx as i, createElementVNode as e } from "vue";
import { RevIcon as m } from "@ds/components/Icon";
const d = /* @__PURE__ */ r({
  name: "IconArrowRightInCircle",
  __name: "IconArrowRightInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(l) {
    const n = l;
    return (s, t) => (a(), o(p(m), c(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...t[0] || (t[0] = [
        e("path", { d: "M6.166 17.834A8.25 8.25 0 1 0 17.834 6.167 8.25 8.25 0 0 0 6.166 17.834m-1.06 1.06c-3.808-3.807-3.808-9.98 0-13.788s9.98-3.808 13.788 0 3.808 9.98 0 13.788-9.98 3.808-13.788 0" }, null, -1),
        e("path", { d: "M16.243 12.75a.75.75 0 0 0 0-1.5H7.757a.75.75 0 0 0 0 1.5h8.486" }, null, -1),
        e("path", { d: "M12.641 15.056a.75.75 0 0 0 1.06 1.06l3.233-3.232a1.25 1.25 0 0 0 0-1.768l-3.232-3.232a.75.75 0 1 0-1.06 1.06L15.696 12l-3.056 3.056" }, null, -1),
        e("path", { d: "M13.702 16.116a.75.75 0 0 1-1.06-1.06l2.305-2.306h-7.19a.75.75 0 1 1 0-1.5h7.19l-2.306-2.306a.75.75 0 0 1 1.06-1.06l3.233 3.232a1.25 1.25 0 0 1 0 1.768l-3.232 3.232" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
